// extracted by mini-css-extract-plugin
module.exports = {"box":"Banner_box__2xc3R","con":"Banner_con__3ME2G"};